import React, { useState, useEffect, useRef } from 'react';
import categories from './categories';
import prompts from './prompts';
import './PromptListPage.css';

const PromptListPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedMiddleCategory, setSelectedMiddleCategory] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // サイドバーの参照を作成
  const sidebarRef = useRef(null);

  // サイドバー外のクリックを検知
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        isSidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isSidebarOpen]);

  const toggleCategory = (cat) => {
    if (selectedCategory === cat) {
      setSelectedCategory(null);
      setExpandedCategories({});
    } else {
      setSelectedCategory(cat);
      setExpandedCategories({ [cat]: true });
    }
    setSelectedMiddleCategory(null);
  };

  const filteredPrompts = prompts.filter((prompt) => {
    const matchesCategory = selectedCategory
      ? prompt.largeCategory === selectedCategory
      : true;
    const matchesMiddleCategory = selectedMiddleCategory
      ? prompt.middleCategory.includes(selectedMiddleCategory)
      : true;
    return matchesCategory && matchesMiddleCategory;
  });

  return (
    <div className="prompt-list-page">
      {/* ハンバーガーメニュー */}
      <button
        className="hamburger-menu"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        {isSidebarOpen ? '✕' : '☰'}
      </button>

      {/* サイドバー */}
      <div
        ref={sidebarRef} // サイドバーに参照を割り当て
        className={`prompt-sidebar ${isSidebarOpen ? 'open' : ''}`}
      >
        <button
          onClick={() => {
            setSelectedCategory(null);
            setSelectedMiddleCategory(null);
            setExpandedCategories({});
            setIsSidebarOpen(false);
          }}
        >

          すべてのカテゴリー
        </button>
        <ul>
          {Object.keys(categories).map((cat) => (
            <li key={cat}>
              <button
                onClick={() => toggleCategory(cat)}
                className={selectedCategory === cat ? 'active' : ''}
                style={{
                  color:
                    selectedCategory === cat
                      ? categories[cat].icon.props.fill
                      : '',
                }}
              >
                <span>{categories[cat].icon}</span>
                {cat}
              </button>
              {expandedCategories[cat] && (
                <ul>
                  {categories[cat].subcategories.map((subcat) => (
                    <li key={subcat}>
                      <button
                        onClick={() => setSelectedMiddleCategory(subcat)}
                        className={
                          selectedMiddleCategory === subcat ? 'active' : ''
                        }
                        style={{
                          color:
                            selectedMiddleCategory === subcat
                              ? categories[cat].icon.props.fill
                              : '',
                        }}
                      >
                        {subcat}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* プロンプトリスト */}
      <div className="prompt-list">
        <div className="prompt-header">
          <h1>企業分析での生成AI 活用事例</h1>
          <p className="page-description">
            実務で使える企業分析のためのプロンプトを紹介します。
          </p>
        </div>
        {filteredPrompts.length === 0 ? (
          <p>選択されたカテゴリに該当するプロンプトは見つかりません。</p>
        ) : (
          <div className="prompt-grid">
            {filteredPrompts.map((prompt) => (
              <div
                key={prompt.id}
                className="prompt-card"
                onClick={() => (window.location.href = `/prompts/${prompt.id}`)}
                style={{ cursor: 'pointer' }}
              >
                <div className="card-header">
                  <p className="prompt-card-date">{prompt.date}</p>
                  <div className="category-icon">
                    {categories[prompt.largeCategory]?.icon}
                  </div>
                </div>
                <h2>{prompt.title}</h2>
                <div className="prompt-prompt">
                  {typeof prompt.prompt === 'string' ? (
                    // 文字列の場合は適切に処理
                    prompt.prompt.length > 100 ? (
                      `${prompt.prompt.substring(0, 100)}...`
                    ) : (
                      prompt.prompt.split('\n').map((line, index) => <p key={index}>{line}</p>)
                    )
                  ) : (
                    // JSXの場合はそのままレンダリング
                    prompt.prompt || <p>有効なヘルプ内容が見つかりません。</p>
                  )}
                </div>
                {/* サブカテゴリーを表示 */}
                <div className="subcategories">
                  {prompt.middleCategory &&
                    prompt.middleCategory.map((subcat, index) => (
                      <span key={index} className="subcategory">
                        {subcat}
                      </span>
                    ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PromptListPage;